import qs from 'qs';

import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const passwordResetValid = payload =>
  httpClient.post(apis.PASSWORD_RESET_VALID, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

export const passwordResetResetWithToken = payload =>
  httpClient.post(apis.PASSWORD_RESET_RESET_WITH_TOKEN, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
